
import React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import CopyrightabilityEngine from "../components/CopyrightabilityEngine";
import StakeholderCallout from "../components/StakeholderCallout";
import IndustryCompliance from "../components/IndustryCompliance";
import MusicClassification from "../components/MusicClassification";
import AIMusicFrameworkSection from "../components/AIMusicFrameworkSection";
// import LaunchTimeline from "../components/LaunchTimeline";
import Newsletter from "../components/Newsletter";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";

const Index: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "TagMusic",
    "url": "https://your-domain.com",
    "description": "Solving copyrightability for AI-assisted music with intentional AI usage reporting and measurement of human contribution in modern music production.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://your-domain.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <SEOHead 
        title="TagMusic | AI Music Framework & Copyrightability Engine for AI-Assisted Music"
        description="Solving copyrightability for AI-assisted music with intentional AI usage reporting and measurement of human contribution in modern music production. Join the revolution in AI music classification."
        keywords="AI music, copyrightability engine, AI music framework, music classification, AI-assisted music, intentional AI usage, music production, copyright, AI in music industry"
        canonical="https://your-domain.com/"
        structuredData={structuredData}
      />
      <div className="bg-gradient-to-b from-tagblue to-tagblue/80">
        <Navbar />
        <HeroSection />
      </div>
      
      <CopyrightabilityEngine />
      <StakeholderCallout />
      <IndustryCompliance />
      <MusicClassification />
      <AIMusicFrameworkSection />
      {/* <LaunchTimeline /> */}
      <Newsletter />
      <Footer />
    </div>
  );
};

export default Index;
